export default __webpack_public_path__ + "static/media/discord-logo-black.c4900a9d.svg";